export const serializeDateForSearch = (date, asUtcDateOnly = false) => {
  if (!date) return date;

  if (asUtcDateOnly) {
    const d = new Date(date);
    return Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());
  }

  return new Date(date).getTime();
};

export const deserializeDateForPicker = (value, asUtcDateOnly = false) => {
  if (!value) return null;

  if (asUtcDateOnly) {
    const d = new Date(Number(value));
    return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
  }

  return new Date(Number(value));
};
